// Table types
const TableTypes = {
  MEDIA: 'media',
  DATA: 'my_tables',
  REPORTS: 'reports',
};

export default TableTypes;
